import { gql } from '@edreamsodigeo/frontend-api-client';
import { itinerarySearchItinerary } from './itinerarySearchItinerary';
import { api as AirlineTrackingInfo } from './airlineTracking';

export const ITINERARY_SEARCH_QUERY = gql`
  query itinerarySearch($searchRequest: SearchRequest!) {
    itinerarySearch(searchRequest: $searchRequest) {
      searchId
      searchCode {
        code
        message
      }
      priceTypeDisplayed
      itineraries {
        ...ItinerarySearchItineraryFragment
      }
      externalSelection {
        id
        segmentKeys
      }
      campaignsItineraryLists {
        campaignItineraryIds
        campaignKey
      }
      freeCancellationItineraryIds
      fees {
        id
        type {
          id
          name
          paymentMethod
        }
      }
      locations {
        id
        location {
          id
          iata
          cityIata
          cityName
          name
          countryName
          locationType
        }
      }
      carriers {
        id
        carrier {
          id
          name
          supportUrl
        }
      }
      insuranceOffers {
        id
        insuranceOffer {
          id
          url
          policy
        }
      }
      carbonFootprints {
        id
        carbonFootprint {
          isEco
          ecoPercentageThanAverage
          totalCo2Kilos
          totalCo2eKilos
        }
      }
      campaignConfigs {
        id
        campaignConfig {
          primeDayConfig {
            isPrimeDayFare
            primeDayFareType
          }
        }
      }
      trackingInfo {
        returningUserDeviceId
        airlinePositionTracking {
          ...AirlineTrackingInfo
        }
        airlineSteeringTracking {
          ...AirlineTrackingInfo
        }
      }
    }
  }
  ${AirlineTrackingInfo}
  ${itinerarySearchItinerary}
`;
